var map = {
	"./EscudoColombia.png": "c10c",
	"./bg-footer.png": "313d",
	"./con_proc.png": "939c",
	"./con_proc_hover.png": "96b8",
	"./consulta_procesos.png": "a735",
	"./cpnu.png": "a9a1",
	"./filter-disabled.png": "206a",
	"./filter.png": "03cb",
	"./justicia.png": "c3ac",
	"./justicia_icon.png": "605a",
	"./justicia_icon_hover.png": "7ebf",
	"./logo.png": "cf05",
	"./logo1.png": "534f",
	"./proc_nal_unificada_icon.png": "f090",
	"./proc_nal_unificada_icon_hover.png": "2950"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "9e01";